/** The value of an item's property, looked up by a column key. */
const valueOf = (item: object, key: string): unknown => new Map(Object.entries(item)).get(key);

/** The text of a cell without a scoped slot: the value as `String()` prints it (`undefined` for a missing one). */
export const cellText = (item: object, key: string): string => String(valueOf(item, key));

/** The row classes an item brings in its `_classes` property (a string; false or a missing one adds none). */
export const rowClasses = (item: object): string => {
  const classes = valueOf(item, '_classes');
  if (typeof classes === 'string') return classes;
  return '';
};
